import React, { createContext, useContext, useEffect, useState } from "react";
import { useLocation } from "react-router";
import SideBar from "./Sidebar";
import Header from "../header/Header";
import SearchBar from "../search-bar/SearchbarLayout";
import { HiColorSwatch } from "react-icons/hi";
import MiniDrawer from "./Sidebar";
import Tooltip from "@mui/material/Tooltip";
import Button from "@mui/material/Button";
import FooterOB from "../footer/footer";
import { ThemeContext } from "../../../context/themeProviderContext";
import ColorPicker from "../../../components/OB/ColorPicker";
import Breadcrumbs from "../search-bar/Breadcrumbs";
import Footer from "../footer/footer";
import  SessionStorageService  from "../../../services/StorageService";

export const DrawerContext = createContext<any>({});

export default function Layout({ children }: any,props:any) {
  const [isOpen, setIsOpen] = useState(false);
  const [isOpenDrawer, setIsOpenDrawer] = useState(false);
  const location = useLocation();
  const pathname = location.pathname;
  const user=SessionStorageService.getUserInfo()
  const { primaryColor, setPrimaryColor, secondaryColor, setSecondaryColor, buttonVariant, setButtonVariant }:any = useContext(ThemeContext);

  const handlePrimaryColorChange = (event: any) => {
    const newColor = event.target.value;
    setPrimaryColor(newColor);
    localStorage.setItem("primaryColor", newColor);
  };

  const handleSecondaryColorChange = (event: any) => {
    const newColor = event.target.value;
    setSecondaryColor(newColor);
    localStorage.setItem("secondaryColor", newColor);
  };

  const handleButtonVariantChange = (event: any) => {
    const newVariant = event.target.value;
    setButtonVariant(newVariant);
    localStorage.setItem("buttonVariant", newVariant);
  };

  const toggleColorPicker = () => {
    setIsOpen(!isOpen);
  };

  const noLayoutControl = () => {
    switch (pathname) {
      case "/login":
        return false;
      default:
        return true;
    }
  };

  return pathname.includes("tahsilat") ? (
    <div className="my-2">
      <main>{children}</main>
      <Footer />
    </div>
  ) : noLayoutControl() ? (
    <DrawerContext.Provider value={{ isOpenDrawer, setIsOpenDrawer }}>
      <div className="d-flex" style={{ backgroundColor: "var(--mainBackgroundColor)" }}>
        <MiniDrawer />
        <div className="w-100">
          <Header />
        
         <div  className="d-flex flex-column align-self-strech justify-content-start  px-sm-1 px-md-2 px-lg-3 px-xl-4">
         {pathname==="/anasayfa"?<SearchBar />:null}
         <Breadcrumbs />
         </div>
          <main className="p-1 p-md-2 p-lg-3 pt-0 pt-md-0 pt-lg-0 pt-xl-0 p-xl-4  ">
            {children}
          </main>
          <FooterOB />
        </div>
        {
          (user!=null && user.rol=="ADMIN") ?
          <div style={{ position: "relative", height: "100vh", zIndex: 10 }}>
          <Tooltip title="Change color" arrow>
            <Button
              variant="contained"
              onClick={toggleColorPicker}
              style={{
                position: "fixed",
                top: "50%",
                paddingLeft:"1rem",
                paddingRight:"1rem",
                right: isOpen ? "280px" : "0",
                transition: "right 0.1s",
              }}
            >
              <HiColorSwatch size={26} />
            </Button>
          </Tooltip>
          {
            isOpen && (
              <div
                style={{
                  width: "280px",
                  height: "100%",
                  position: "fixed",
                  top: "0",
                  right: "0",
                  overflow:"auto",
                  backgroundColor: "white",
                  transition: "right 0.6s",
                  zIndex: 1000,
                  boxShadow: "-5px 0 15px rgba(0, 0, 0, 0.2)",
                }}
              >
                <ColorPicker 
                  onPrimaryColorChange={handlePrimaryColorChange} 
                  onSecondaryColorChange={handleSecondaryColorChange} 
                  onButtonVariantChange={handleButtonVariantChange} 
                  buttonVariant={buttonVariant} 
                />
              </div>
            )
          }
        </div> :null
        }
        
      </div>
    </DrawerContext.Provider>
  ) : (
    <main className={noLayoutControl() ? "p-1 p-md-2" : ""} style={{ backgroundColor: "var(--mainBackgroundColor)" }}>
      {children}
    </main>
  );
}
